import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  Renderer2,
  inject,
} from '@angular/core';
import { ActivatedRoute, Router, RouterLinkWithHref } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { CultureFacade } from '../../cultures/facade/cultures.facade';
import { filter, Subscription } from 'rxjs';
import { UrlSafePipe } from '@boels/helpers';

/**
 * Directive to automatically add the culture and replace special characters with UrlSafePipe.
 */
@Directive({
  selector: 'a[cmsRouterLink]',
  standalone: true,
})
export class CmsRouterLinkDirective
  extends RouterLinkWithHref
  implements OnDestroy
{
  private cultureFacade = inject(CultureFacade);
  private urlSafePipe = inject(UrlSafePipe);

  private subs$: Subscription = new Subscription();
  @Input() set cmsRouterLink(commands: any[] | string | undefined | null) {
    this.subs$.add(
      this.cultureFacade
        .getActiveCulture()
        .pipe(filter(Boolean))
        .subscribe((culture) => {
          if (commands) {
            this.routerLink = Array.isArray(commands)
              ? commands.reduce(
                  (previousValue, currentValue) => [
                    ...previousValue,
                    ...currentValue
                      .split('/')
                      .filter((value: string) => value.length > 0)
                      .map((value: string) =>
                        this.urlSafePipe.transform(value),
                      ),
                  ],
                  ['/' + culture],
                )
              : [
                  '/' + culture,
                  ...commands
                    .split('/')
                    .filter((value: string) => value.length > 0)
                    .map((value: string) => this.urlSafePipe.transform(value)),
                ];
          } else {
            this.routerLink = undefined;
          }
        }),
    );
  }

  constructor() {
    const router = inject(Router);
    const route = inject(ActivatedRoute);
    const locationStrategy = inject(LocationStrategy);
    const renderer = inject(Renderer2);
    const el = inject(ElementRef);

    super(router, route, undefined, renderer, el, locationStrategy);
  }

  override ngOnDestroy(): any {
    this.subs$.unsubscribe();
    return super.ngOnDestroy();
  }
}
